import request from '../utils/request.js'

export default {
  // 获取订单列表
  getList (params) {
    return request.post(`order/lists`, params).then(res => res.data)
  },
  
  // 获取订单统计
  getStatistics (params) {
    return request.post(`order/statistics`, params).then(res => res.data)
  },
  
  // 获取订单详情
  getDetail (params) {
    return request.post(`order/detail`, params).then(res => res.data)
  },
  
  // 订单退款
  refund (params) {
    return request.post(`order/refund`, params).then(res => res.data)
  },
  
  // 手动标记缴费
  markPaid (params) {
    return request.post(`order/markPaid`, params).then(res => res.data)
  },
  
  // 导出订单记录
  exportOrders (params) {
    return request.post(`order/export`, params).then(res => res.data)
  },
  
  // 导出未缴费人员名单
  exportUnpaid (params) {
    return request.post(`order/exportUnpaid`, params).then(res => res.data)
  },
  
  // 获取缴费流程列表
  getProcessList (params) {
    return request.post(`order/getProcessList`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/order.js